declare global {
	interface Window {
		LEGAL_INFO?: string;
		PDP_POLICY_URL?: string;
		USER_AGREEMENT_URL?: string;
		SUCCESS_TEXT?: string;
		FAILURE_TEXT?: string;
		BELOW_SLOT_NOTES_TEXT?: string;
		UNAVAILABLE_TEXT?: string;
	}
}

export const LEGAL_INFO = window.LEGAL_INFO || import.meta.env['VITE_LEGAL_INFO'];
export const PDP_POLICY_URL = window.PDP_POLICY_URL || import.meta.env['VITE_PDP_POLICY_URL'];
export const USER_AGREEMENT_URL = window.USER_AGREEMENT_URL || import.meta.env['VITE_USER_AGREEMENT_URL'];
export const BELOW_SLOT_NOTES_TEXT = window.BELOW_SLOT_NOTES_TEXT || import.meta.env.VITE_BELOW_SLOT_NOTES_TEXT;
export const UNAVAILABLE_TEXT = window.UNAVAILABLE_TEXT || import.meta.env.VITE_UNAVAILABLE_TEXT;

export const SUCCESS_TEXT = window.SUCCESS_TEXT || import.meta.env.VITE_SUCCESS_TEXT
export const FAILURE_TEXT = window.FAILURE_TEXT || import.meta.env.VITE_FAILURE_TEXT